/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { UPDATE_ORDER } from './graphql';

export function useUpdateOrder() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [UpdateOrder, { loading: apiLoading, error: apiError }] =
    useMutation(UPDATE_ORDER);

  useEffect(() => {
    setErrorMessage(apiError);
  }, [apiError]);

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function updateOrder(updatedOrder) {
    if (!updatedOrder.orderId) return;
    try {
      const res = await UpdateOrder({
        variables: {
          updateOrderInput: updatedOrder,
        },
      });
      if (res.data.updateOrder.code !== 200) {
        setErrorMessage(
          'Erro ao atualizar informações do pedido, tente novamente mais tarde',
        );
      } else {
        setSuccessMessage('Informações do pedido salvas com sucesso!');
      }
    } catch (e) {
      setErrorMessage(e.message);
    }
  }

  return {
    updateOrder,
    loading: isLoading,
  };
}
